const baseStyle = {
  fontSize: 'md',
  fontWeight: 'normal',
  lineHeight: 'base',
  color: 'white',
  bg: 'gray.800',
  px: '2',
  py: '0',
  '--popper-arrow-bg': 'var(--chakra-colors-gray-800)'
}

export const Tooltip = {
  baseStyle
}
